import { createFileRoute } from "@tanstack/react-router"

import { MemberShell } from "@/components/member-shell"
import { PropertyEditor } from "@/components/property-editor"
import { getAccountFn } from "@/lib/app.functions"
import { requireMemberRoute } from "@/lib/route-guards"

export const Route = createFileRoute("/my-listings/new")({
  loader: async () => {
    await requireMemberRoute("/my-listings/new")
    return getAccountFn()
  },
  head: () => ({
    meta: [{ title: "Create listing · Harbor & Pine Realty" }],
  }),
  component: NewListingPage,
})

function NewListingPage() {
  const { user } = Route.useLoaderData()
  return (
    <MemberShell
      user={user}
      eyebrow="Owner workspace · new record"
      title="Create listing"
      intro="Build a complete fictional property sheet. Choose from the generated demo media library; no upload leaves the application."
    >
      <PropertyEditor isAdmin={user.role === "admin"} />
    </MemberShell>
  )
}
